import { GrossMarginRequestDetail } from "@/services/gross-margin-requests.service";
import { AppColors } from "@/styles/colors";
import { Box, Flex, Text } from "@chakra-ui/react";
import { FileText } from "lucide-react";

interface Props {
    detail: GrossMarginRequestDetail
}

export const ReportDisplay = ({ detail }: Props) => {
    const disponible = detail.informeDisponible ?? false;

    const handleOpen = () => {
        const a = document.createElement("a");
        a.href = detail.urlInforme!;
        a.target = "_blank";
        a.rel = "noopener noreferrer";
        if (detail.nombreInforme?.trim()) a.download = detail.nombreInforme;
        document.body.appendChild(a);
        a.click();
        a.remove();
    };

    return (
        <Box>
            <Text fontWeight={700} fontSize="16px" marginBottom="12px">
                Informe
            </Text>
            <Flex
                flexDir="column"
                border="1px solid"
                borderColor="gray.200"
                borderRadius="6px"
                paddingX="16px"
                paddingY="12px"
                bg="gray.50"
                gap="6px"
            >
                <Flex alignItems="center" gap="8px">
                    <FileText size={16} color={disponible ? AppColors.GRAY_TEXT : AppColors.LIGHT_GRAY_TEXT} />
                    <Text
                        fontSize="14px"
                        fontWeight={500}
                        color={disponible ? AppColors.GREEN_PRIMARY : AppColors.LIGHT_GRAY_TEXT}
                        cursor={disponible ? "pointer" : "default"}
                        _hover={disponible ? { textDecoration: "underline" } : undefined}
                        onClick={disponible ? handleOpen : undefined}
                    >
                        {detail.nombreInforme ?? "Ver informe"}
                    </Text>
                </Flex>
                {detail.notasInforme && (
                    <Text fontSize="13px" color={AppColors.GRAY_TEXT}>
                        {detail.notasInforme}
                    </Text>
                )}
            </Flex>
        </Box>
    );
}